import { render, staticRenderFns } from "./LlTabContent.vue?vue&type=template&id=310e13a2"
import script from "./LlTabContent.vue?vue&type=script&lang=js"
export * from "./LlTabContent.vue?vue&type=script&lang=js"
import style0 from "./LlTabContent.vue?vue&type=style&index=0&id=310e13a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports